import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import MediaQueries from '../../../../styles/Grid/MediaQueries';

export const atLocationTitleCss = css(typography.effra18, {
  fontWeight: fontWeights.medium,
  lineHeight: '30px',
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const statQuantityCss = css(typography.effra34, {
  color: colorsPalette.black,
  fontWeight: fontWeights.light,
  fontSize: 34,
  lineHeight: '40px',
  [MediaQueries.mdAndUp]: {
    marginBottom: 8,
  },
});

export const statTitleCss = css(typography.effra16, {
  color: colorsPalette.grey60,
});

export const statWrapperCss = css({
  marginBottom: 16,
  minWidth: '50%',
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
    minWidth: '100%',
  },
});

export const dividerCss = css({
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  margin: '24px 0 7px',
  width: 148,
  '&.divider-0': {
    margin: '16px 0 7px',
  },
});

export const statsWrapperCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
});
